<template>
    <div :id="id" style="min-height: 430px;"></div>
</template>

<script>
    export default {
        name: 'GoogleTrend',
        props:{
            id: {required: true},
            date:{ default: 'today 5-y'},
            geo: {default:'US'},
            keyword: {required:true}
        },
        data() {
          return {
              script: '',
          }
        },
        watch:{
            'keyword'() {
                this.fetch();
            }
        },
        mounted() {
            if(this.keyword)
            {
                this.fetch();
            }
        },
        methods: {
           fetch() {

               console.log(this);

               const geo = this.geo ? this.geo : 'US';

               if(this.script) {
                   this.script.parentNode.removeChild( this.script );
                   this.script = '';
               }
               if(! this.script) {
                   const script = document.createElement("script");
                   script.src = "https://ssl.gstatic.com/trends_nrtr/2213_RC01/embed_loader.js";
                   script.async = true;
                   document.head.appendChild(script);
                   this.script = script;
               }

               this.script.onload = () => {
                   document.getElementById(this.id).innerHTML = "";
                   var divElem = document.getElementById(this.id);
                   trends.embed.renderExploreWidgetTo(divElem, "TIMESERIES", {
                           "comparisonItem": [{
                               "keyword": this.keyword,
                               "geo": this.geo,
                               "time": this.date
                           }],
                           "category": 0,
                           "property": ""
                       },
                       {
                           "exploreQuery": "q=" + this.keyword + "&date="+this.date+"&geo=" + geo,
                           "guestPath": "https://trends.google.com:443/trends/embed/"
                       });
               }

           }
        }
    };
</script>
